import { Menu, MenuButton, MenuItem, MenuItems, Radio, RadioGroup } from "@headlessui/react";
import axios from "axios";
import { addDays, format, lastDayOfWeek, startOfWeek } from "date-fns";
import React from "react";
import { Calendar as MultiPickCalendar } from "react-multi-date-picker";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";


import { dateInArray } from "../../../../helpers";
import { useLocalStorage } from "../../../../hooks";

import "../../../../styles/Calendar.css";

import calender_black from "../../../../assets/calender_black.svg";
import marker from "../../../../assets/location.svg";
import { TwCalendarPicker, TwFormHelperText, TwLocationInput, TwSelectGroup, TwTimePicker } from "../../../../components/tailwind";
import { loadingState } from "../../../../redux/reducers/loadingReducer";
import { getUrlForUsers } from "../../../../utils/confighelpers";
import AddLocationModal from "../../../myLocation/AddLocationModal";
import { ChevronDownIcon } from "@heroicons/react/20/solid";
import moment from "moment";
import { useTranslation } from "react-i18next";


export default function AddScheduleStep1({
  handleRadioValueChange,
  handleRadioValueChange2,
  handleStartDateChange,
  handleEndDateChange,
  handleStartTimeChange,
  handleEndTimeChange,
  handleDaysInWeekChange,
  formValues,
  setFormValues,
  formErrors,
  sessionTimings,
  handleLocationChange,
  handleClearDaysInWeek,
  handleCalendarDaysChange,
  handleNextStep,
  disableButton,
  clearFormValues,
}) {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const loadingReduxState = useSelector(loadingState);
  const [isEndDateDisabled, setEndDateDisabled] = React.useState(false);
  const [userLocations, setUserLocations] = React.useState([]);
  const [userToken] = useLocalStorage("userToken");
  const [openStartDate, setOpenStartDate] = React.useState(false);
  const [openEndDate, setOpenEndDate] = React.useState(false);
  const [openStartTime, setOpenStartTime] = React.useState(false);
  const [locationModalOpen, setLocationModalOpen] = React.useState(false);

  const options = [
    {
      value: "One Time",
      text: t("myEvents.oneTime"),
    },
  ];

  const options2 = [
    {
      value: "Daily",
      text: "Daily",
    },
    {
      value: "Weekly",
      text: "Weekly",
    },
  ];

  React.useEffect(() => {
    getListOfLocation();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    if (formValues.radioValue === "One Time") {
      setEndDateDisabled(true);
    } else {
      setEndDateDisabled(false);
    }
  }, [formValues.radioValue]);


  const getListOfLocation = async () => {
    const locsConfig = {
      method: "get",
      url: `${getUrlForUsers()}listOfLocation`,
      headers: {
        "x-access-token": userToken,
      },
    };
    const requestLocs = await axios(locsConfig);
    setUserLocations([...requestLocs.data.data]);
  }

  const RadioOption = ({ value, text }) => {
    return (
      <button
        onClick={() =>
          value === "Custom" ? handleClearDaysInWeek() : undefined
        }
      >
        <Radio value={value}>
          {({ checked }) => (
            <span
              className={`w-28 sm:w-32 h-10 rounded-xl grid place-items-center font-semibold text-[12.5px] cursor-pointer ${checked
                ? "bg-black text-white"
                : "bg-white border border-black text-black"
                }`}
            >
              {text}
            </span>
          )}
        </Radio>
      </button>
    );
  };

  const renderDays = () => {
    const dateFormat = "EEEEEE";
    const days = [];
    const startDate = startOfWeek(new Date(), {
      weekStartsOn: 0,
    });
    const endDate = lastDayOfWeek(new Date(), {
      weekStartsOn: 0,
    });
    let day = startDate;
    while (day <= endDate) {
      for (let i = 0; i < 7; i++) {
        const cloneDay = day;
        days.push(
          <div
            className={`rounded-full cursor-pointer ${dateInArray(day, formValues.daysInWeek)
              ? "bg-secondary font-semibold text-white"
              : "bg-[rgba(72,27,58,0.1)] font-light text-plain-gray"
              } text-sm sm:text-xs flex justify-center items-center w-10 h-10 sm:w-12 sm:h-12`}
            key={i}
            onClick={() => {
              handleDaysInWeekChange(cloneDay);
            }}
          >
            {format(day, dateFormat)}
          </div>
        );
        day = addDays(day, 1);
      }
    }
    return (
      <div className={"flex flex-row gap-2 sm:gap-2 lg:gap-2"}>{days}</div>
    );
  };

  return (
    <div className={"[flex flex-row] grid grid-cols-1 sm:grid-cols-2 gap-3 w-full"}>
      <div className="p-4 flex flex-col gap-2 border-2 border-bright-gray rounded-2xl">
        <div className="flex  gap-2 justify-between">
          <label className="font-bold text-xl">{t("myEvents.eventSchedule")}</label>
          <div className="">
            <Menu as="div" className="relative inline-block text-left">
              <div>
                <MenuButton className="inline-flex w-full justify-center gap-x-1.5 rounded-md bg-white px-1.5 py-1 text-sm font-semibold text-gray-900 [shadow-sm] ring-0 ring-inset ring-gray-300 hover:bg-gray-50">
                  {options.find((f) => (f.value == (formValues.radioValue2 ? formValues.radioValue2 + " " : "") + formValues.radioValue)) ? options.find((f) => (f.value == (formValues.radioValue2 ? formValues.radioValue2 + " " : "") + formValues.radioValue)).value : ""}
                  <ChevronDownIcon aria-hidden="true" className="-mr-1 size-5 text-gray-400" />
                </MenuButton>
              </div>

              <MenuItems
                transition
                className="absolute right-0 z-10 mt-2 w-40 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black/5 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in"
              >
                <div className="py-1">
                  {options.map((opt, idx) => (
                    <MenuItem key={idx}><button
                      type="button"
                      onClick={() => {
                        if (opt.value == "One Time") {
                          handleRadioValueChange(opt.value)
                          handleRadioValueChange2("")
                          handleEndDateChange(formValues?.startDate);
                        } else {
                          let splitOption = opt.value.split(" ")
                          handleRadioValueChange(splitOption[1])
                          handleRadioValueChange2(splitOption[0])
                        }
                      }}
                      className="w-full px-4 py-2 text-left text-sm text-gray-700 data-[focus]:bg-gray-100 data-[focus]:text-gray-900 data-[focus]:outline-none"
                    >
                      {opt.text}
                    </button></MenuItem>
                  ))}
                </div>
              </MenuItems>
            </Menu>
          </div>
        </div>
        {/* <RadioGroup
          value={formValues.radioValue}
          onChange={handleRadioValueChange}
          className={"flex flex-row items-center gap-2"}
        >
          {options.map((opt, idx) => (
            <RadioOption key={idx} {...opt} />
          ))}
        </RadioGroup> */}
        {false && formValues.radioValue === "Recurrent" && (
          // <RadioGroup
          // >
          //   {options2.map((opt, idx) => (
          //     <RadioOption key={idx} {...opt} />
          //   ))}
          // </RadioGroup>
          <div className="flex justify-end">
            <Menu as="div" className="relative inline-flex text-left">
              <div>
                <MenuButton className="inline-flex [w-full] justify-center gap-x-1.5 rounded-md bg-white px-1.5 py-1 text-sm font-semibold text-gray-900 [shadow-sm] ring-0 ring-inset ring-gray-300 hover:bg-gray-50">
                  {formValues.radioValue2}
                  <ChevronDownIcon aria-hidden="true" className="-mr-1 size-5 text-gray-400" />
                </MenuButton>
              </div>

              <MenuItems
                transition
                className="absolute right-0 z-10 mt-2 w-32 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black/5 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in"
              >
                <div className="py-1">
                  {options2.map((opt, idx) => (
                    <MenuItem key={idx}><button
                      type="button"
                      onClick={() => {
                        handleRadioValueChange2(opt.value)
                      }}
                      className="w-full px-4 py-2 text-left text-sm text-gray-700 data-[focus]:bg-gray-100 data-[focus]:text-gray-900 data-[focus]:outline-none"
                    >
                      {opt.text}
                    </button></MenuItem>
                  ))}
                </div>
              </MenuItems>
            </Menu>
          </div>
        )}
        {formValues.radioValue === "Recurrent" && formValues.radioValue2 === "Weekly" && (
          <>
            <h4 className={"font-medium text-[15.35px] text-secondary"}>
              {t("myEvents.selectDays")}
            </h4>
            {renderDays()}
          </>
        )}
        {formValues.radioValue === "Recurrent" && formValues.radioValue2 === "Custom" && (
          <>
            <MultiPickCalendar
              className='bookzy-calendar bookzy-border !z-10'
              minDate={new Date()}
              value={formValues.daysInWeek}
              onChange={handleCalendarDaysChange}
              multiple
              // numberOfMonths={2}
              numberOfMonths={loadingReduxState.screenSizeType && ["3xs", "2xs", "xs", "xs", "sm"].indexOf(loadingReduxState.screenSizeType) >= 0 ? 1 : 2}
              weekDays={["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"]}
              mapDays={({
                date,
                today,
                selectedDate,
                currentMonth,
                isSameDate,
              }) => {
                let props = {};
                if (isSameDate(date, today)) {
                  props.className = "default-current-date";
                  props.style = {
                    ...props.style,
                    border: "1px solid #777",
                  };
                }
                const dateTransformed = date.toDate();
                const selectedDatesTransformed = selectedDate.map((day) =>
                  day.toDate()
                );
                if (dateInArray(dateTransformed, selectedDatesTransformed)) {
                  props.className = "selected-date";
                }
                return props;
              }}
            />
          </>
        )}
        {formValues.radioValue2 !== "Custom" && (
          <>
            <div className="flex flex-col sm:flex-row gap-4">
              <TwCalendarPicker
                outerContainerClassName="flex-1"
                // label={formValues.radioValue === "One Time" ? t("myEvents.eventDate") : t("myEvents.startDate")}
                label={"Start Date & Time"}
                name={"startDate"}
                leftIcon={(<img className={""} src={calender_black} alt={""} />)}
                format="ddd, DD MMM YYYY"
                value={formValues?.startDate || ""}
                minDate={moment().subtract(1, "day").toDate()}
                // minDate={moment().add(1, "day").toDate()}
                onChange={(newValue) => {
                  handleStartDateChange(newValue);
                  // Always update end date to match start date when start date changes
                  setFormValues((prevValues) => ({
                    ...prevValues,
                    endDateTime: newValue,
                  }));
                }}
                errors={formErrors} />
              <TwTimePicker
                outerContainerClassName="sm:!w-52 sm:!max-w-52 md:!max-w-52"
                // containerClassName="!w-auto"
                // inputClass="!w-auto"
                label={<>&nbsp;</>}
                name={"startTime"}
                format={"HH:mm"}
                leftIcon={(
                  <svg className={"[size-5 sm:size-4]"} width="18" height="18" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M6.11692 12.978C2.73828 12.978 0 10.2397 0 6.86106C0 3.48242 2.73828 0.744141 6.11692 0.744141C9.49556 0.744141 12.2338 3.48242 12.2338 6.86106C12.2338 10.2397 9.49556 12.978 6.11692 12.978ZM5.54346 6.86106C5.54346 7.05221 5.63904 7.23142 5.79913 7.31744L8.09297 8.84667C8.35581 9.0426 8.71183 8.97092 8.86714 8.70808C9.06308 8.44525 8.99139 8.08922 8.72856 7.91241L6.69038 6.55521V3.61145C6.69038 3.29365 6.43471 3.03799 6.09542 3.03799C5.79913 3.03799 5.52195 3.29365 5.52195 3.61145L5.54346 6.86106Z" fill="#000" />
                  </svg>)}
                value={formValues.startTime || ""}
                onChange={(date, dateParams) => {
                  // handleStartTimeChange(date.toDate());
                  return handleStartTimeChange(date);
                }}
                errors={formErrors} />
            </div>
            <div className={`flex flex-col sm:flex-row gap-4`}>
              <TwCalendarPicker
                outerContainerClassName="flex-1"
                // label={t("myEvents.endDate")}
                label={"End Date & Time"}
                name={"endDateTime"}
                leftIcon={(<img className={""} src={calender_black} alt={""} />)}
                format="ddd, DD MMM YYYY"
                // format="DD/MM/YYYY"
                value={formValues?.endDateTime || ""}
                // disabled={isEndDateDisabled}
                minDate={formValues?.startDate ? (typeof formValues.startDate.toDate === 'function' ? formValues.startDate.toDate() : new Date(formValues.startDate)) : moment().subtract(1, "day").toDate()}
                onChange={(newValue) => {
                  setFormValues((prevValues) => ({
                    ...prevValues,
                    endDateTime: newValue,
                  }));
                }}
                errors={formErrors}
              />
              <TwTimePicker
                outerContainerClassName="sm:!w-52 sm:!max-w-52 md:!max-w-52"
                // containerClassName="!w-auto"
                // inputClass="!w-auto"
                label={<>&nbsp;</>}
                name={"endTime"}
                format={"HH:mm"}
                leftIcon={(
                  <svg className={"[size-5 sm:size-4]"} width="18" height="18" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M6.11692 12.978C2.73828 12.978 0 10.2397 0 6.86106C0 3.48242 2.73828 0.744141 6.11692 0.744141C9.49556 0.744141 12.2338 3.48242 12.2338 6.86106C12.2338 10.2397 9.49556 12.978 6.11692 12.978ZM5.54346 6.86106C5.54346 7.05221 5.63904 7.23142 5.79913 7.31744L8.09297 8.84667C8.35581 9.0426 8.71183 8.97092 8.86714 8.70808C9.06308 8.44525 8.99139 8.08922 8.72856 7.91241L6.69038 6.55521V3.61145C6.69038 3.29365 6.43471 3.03799 6.09542 3.03799C5.79913 3.03799 5.52195 3.29365 5.52195 3.61145L5.54346 6.86106Z" fill="#000" />
                  </svg>)}
                value={formValues.endTime || ""}
                onChange={(date, dateParams) => {
                  return handleEndTimeChange(date);
                }}
                errors={formErrors} />
            </div>
            <div className={`${(formValues.radioValue === "One Time") ? "hidden" : "flex"} flex-col sm:flex-row gap-2`}>
              <TwCalendarPicker
                outerContainerClassName="flex-1"
                label={t("myEvents.endDate")}
                name={"endDate"}
                leftIcon={(<img className={""} src={calender_black} alt={""} />)}
                format="ddd, DD MMM YYYY"
                // format="DD/MM/YYYY"
                value={formValues?.endDate || ""}
                disabled={isEndDateDisabled}
                minDate={new Date()}
                onChange={(newValue) => {
                  handleEndDateChange(newValue);
                }}
                errors={formErrors}
                helperText={isEndDateDisabled ? t("myEvents.endDateHelperText") : ""}
              />
              {/* <TwTimePicker
                outerContainerClassName="sm:!w-32 sm:!max-w-32 md:!max-w-32"
                // containerClassName="!w-auto"
                // inputClass="!w-auto"
                label={t("myEvents.time")}
                name={"endTime"}
                format={"HH:mm"}
                leftIcon={(
                  <svg className={"[size-5 sm:size-4]"} width="18" height="18" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M6.11692 12.978C2.73828 12.978 0 10.2397 0 6.86106C0 3.48242 2.73828 0.744141 6.11692 0.744141C9.49556 0.744141 12.2338 3.48242 12.2338 6.86106C12.2338 10.2397 9.49556 12.978 6.11692 12.978ZM5.54346 6.86106C5.54346 7.05221 5.63904 7.23142 5.79913 7.31744L8.09297 8.84667C8.35581 9.0426 8.71183 8.97092 8.86714 8.70808C9.06308 8.44525 8.99139 8.08922 8.72856 7.91241L6.69038 6.55521V3.61145C6.69038 3.29365 6.43471 3.03799 6.09542 3.03799C5.79913 3.03799 5.52195 3.29365 5.52195 3.61145L5.54346 6.86106Z" fill="#000" />
                  </svg>)}
                value={formValues.endTime || ""}
                onChange={(date, dateParams) => {
                  return handleEndTimeChange(date);
                }}
                errors={formErrors} /> */}
            </div>
            {formErrors["scheduleError"] && (
              <TwFormHelperText error={true}>{formErrors["scheduleError"]}</TwFormHelperText>
            )}
          </>
        )}
        {/* <div className="flex [flex-col sm:]flex-row  gap-4 items-center items-start w-full sm:w-full sm:max-w-sm md:max-w-lg" >
          <TwTimePicker
            outerContainerClassName=""
            // containerClassName="!w-auto"
            // inputClass="!w-auto"
            label={t("myEvents.from")}
            name={"startTime"}
            format={"HH:mm"}
            leftIcon={(
              <svg className={"[size-5 sm:size-4]"} width="18" height="18" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M6.11692 12.978C2.73828 12.978 0 10.2397 0 6.86106C0 3.48242 2.73828 0.744141 6.11692 0.744141C9.49556 0.744141 12.2338 3.48242 12.2338 6.86106C12.2338 10.2397 9.49556 12.978 6.11692 12.978ZM5.54346 6.86106C5.54346 7.05221 5.63904 7.23142 5.79913 7.31744L8.09297 8.84667C8.35581 9.0426 8.71183 8.97092 8.86714 8.70808C9.06308 8.44525 8.99139 8.08922 8.72856 7.91241L6.69038 6.55521V3.61145C6.69038 3.29365 6.43471 3.03799 6.09542 3.03799C5.79913 3.03799 5.52195 3.29365 5.52195 3.61145L5.54346 6.86106Z" fill="#000" />
              </svg>)}
            value={formValues.startTime || ""}
            onChange={(date, dateParams) => {
              // handleStartTimeChange(date.toDate());
              return handleStartTimeChange(date);
            }}
            errors={formErrors} />
          <div className="w-3 border border-gray-500 mt-8"></div>
          <TwTimePicker
            outerContainerClassName=""
            // containerClassName="!w-auto"
            // inputClass="!w-auto"
            label={t("myEvents.till")}
            name={"endTime"}
            format={"HH:mm"}
            leftIcon={(
              <svg className={"[size-5 sm:size-4]"} width="18" height="18" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M6.11692 12.978C2.73828 12.978 0 10.2397 0 6.86106C0 3.48242 2.73828 0.744141 6.11692 0.744141C9.49556 0.744141 12.2338 3.48242 12.2338 6.86106C12.2338 10.2397 9.49556 12.978 6.11692 12.978ZM5.54346 6.86106C5.54346 7.05221 5.63904 7.23142 5.79913 7.31744L8.09297 8.84667C8.35581 9.0426 8.71183 8.97092 8.86714 8.70808C9.06308 8.44525 8.99139 8.08922 8.72856 7.91241L6.69038 6.55521V3.61145C6.69038 3.29365 6.43471 3.03799 6.09542 3.03799C5.79913 3.03799 5.52195 3.29365 5.52195 3.61145L5.54346 6.86106Z" fill="#000" />
              </svg>)}
            value={formValues.endTime || ""}
            onChange={(date, dateParams) => {
              return handleEndTimeChange(date);
            }}
            errors={formErrors} />
        </div> */}
        <div className="hidden [flex] flex-col sm:flex-row  gap-4 items-start w-full sm:w-full sm:max-w-sm md:max-w-lg" >
          <TwTimePicker
            outerContainerClassName="sm:!w-auto flex-1"
            // containerClassName="!w-auto"
            // inputClass="!w-auto"
            label={t("myEvents.time")}
            name={"startTime"}
            format={"HH:mm"}
            leftIcon={(
              <svg className={"[size-5 sm:size-4]"} width="18" height="18" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M6.11692 12.978C2.73828 12.978 0 10.2397 0 6.86106C0 3.48242 2.73828 0.744141 6.11692 0.744141C9.49556 0.744141 12.2338 3.48242 12.2338 6.86106C12.2338 10.2397 9.49556 12.978 6.11692 12.978ZM5.54346 6.86106C5.54346 7.05221 5.63904 7.23142 5.79913 7.31744L8.09297 8.84667C8.35581 9.0426 8.71183 8.97092 8.86714 8.70808C9.06308 8.44525 8.99139 8.08922 8.72856 7.91241L6.69038 6.55521V3.61145C6.69038 3.29365 6.43471 3.03799 6.09542 3.03799C5.79913 3.03799 5.52195 3.29365 5.52195 3.61145L5.54346 6.86106Z" fill="#000" />
              </svg>)}
            value={formValues.startTime || ""}
            onChange={(date, dateParams) => {
              // handleStartTimeChange(date.toDate());
              handleStartTimeChange(date);
            }}
            errors={formErrors} />
          <div
            className={
              "w-full sm:w-auto p-4 py-3 sm:py-5 sm:mt-9 flex flex-row items-center gap-4 bg-bright-gray rounded-lg  flex-1"
            }
          >
            {/* <img className={"w-5"} src={Clock_Dark} alt={""} /> */}
            <svg width="18" height="18" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M6.11692 12.978C2.73828 12.978 0 10.2397 0 6.86106C0 3.48242 2.73828 0.744141 6.11692 0.744141C9.49556 0.744141 12.2338 3.48242 12.2338 6.86106C12.2338 10.2397 9.49556 12.978 6.11692 12.978ZM5.54346 6.86106C5.54346 7.05221 5.63904 7.23142 5.79913 7.31744L8.09297 8.84667C8.35581 9.0426 8.71183 8.97092 8.86714 8.70808C9.06308 8.44525 8.99139 8.08922 8.72856 7.91241L6.69038 6.55521V3.61145C6.69038 3.29365 6.43471 3.03799 6.09542 3.03799C5.79913 3.03799 5.52195 3.29365 5.52195 3.61145L5.54346 6.86106Z" fill="#808080" />
            </svg>

            <p className={"text-[#808080] text-[15px]"}>
              {sessionTimings}
            </p>
          </div>
        </div>
      </div>
      <div className="p-4 flex flex-col gap-2 border-2 border-bright-gray rounded-2xl">
        <label className="font-bold text-xl">{t("myEvents.eventVenue")}</label>
        <TwLocationInput
          label={t("myEvents.venueAddress")}
          name={"postalAddress"}
          leftIcon={(<img className={""} src={marker} alt={""} />)}
          defaultLocationSelect={formValues.location}
          onLocationSelect={(data, postAdd) => {

            // const newValue = JSON.parse(postAdd);
            const newValue = data;
            if (newValue != null) {
              handleLocationChange(newValue);
            } else {
              handleLocationChange("");
              setLocationModalOpen(true);
            }

            // setAddress(data);
          }}
          errors={formErrors}
        />
        {/* <TwSelectGroup
        label={t("myEvents.location")}
        placeholder={t("myEvents.selectLocation")}
        name={"location"}
        leftIcon={<img src={marker} alt={""} className="w-4" />}
        options={[{
          value: "", title: t("myEvents.selectLocation"),
        }, ...userLocations.length ? userLocations.map((loc, idx) => {
          return { value: JSON.stringify(loc), title: loc.addressName }
        }) : [], {
          value: JSON.stringify(null), title: t("inputFieldsTitle.addNewLocation"), onClick: () => {
            setLocationModalOpen(true);
          }
        }]}
        defaultValue={JSON.stringify(formValues.location)}
        value={JSON.stringify(formValues.location)}
        onChange={(event) => {
          const newValue = JSON.parse(event.target.value);
          if (newValue != null) {
            handleLocationChange(newValue);
          } else {
            handleLocationChange("");
            setLocationModalOpen(true);
          }

        }}
        errors={formErrors} /> */}
        <AddLocationModal
          open={locationModalOpen}
          handleClose={() => setLocationModalOpen(false)}
          handleUpdate={() => { setLocationModalOpen(false); getListOfLocation(); }}
        />
      </div>
    </div>
  );
}
